class ProductCard extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.data = {}
  }

  async connectedCallback () {
    const propData = this.getAttribute('data-prop-data')

    if (propData) {
      this.data = JSON.parse(propData)

      this.renderInitial()
    }
  }

  async renderInitial () {
    const productHandle = this.handle

    try {
      const response = await fetch(
        `/products/${productHandle}?section_id=product-card`,
      )
      if (!response.ok) throw new Error('Failed to fetch product card section')
      const text = await response.text()
      const html = new DOMParser().parseFromString(text, 'text/html')

      const productCardContent = html.querySelector(
        `#shopify-section-product-card`,
      )
      if (productCardContent) {
        this.innerHTML = productCardContent.innerHTML
      }
    } catch (error) {
      console.error('Failed to fetch product card section:', error)
    }
  }

  get handle () {
    return this.data.url.split('products/').pop()
  }
}

customElements.define('product-card', ProductCard)
